module.exports = __webpack_public_path__ + "static/media/i-16.19d5be35.jpg";